<template>
  <v-app>
    <v-main>
      <v-container class="fill-height d-flex flex-column align-center justify-center">
        <v-card class="pa-5" max-width="400">
          <v-card-title class="headline red--text text-center">
            Atención
          </v-card-title>
          <v-card-text class="text-center">
            Para continuar con la cesión, primero debe completar el movimiento que tiene en proceso para este vehículo.
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click="$router.push({ name: 'Vehiculo' })">
              Volver al panel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'CompletarMovimientoPrimero'
}
</script>

<style scoped>
.red--text {
  color: #e53935 !important;
}
</style>
